import React from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';

export default class ScrollLazyLoad extends React.Component {
  constructor(props) {
    super(props);

    this.state = { active: true };

    this.containment = document.querySelector(props.container) || document.body;
    if (props.viewportOffset) {
      const clientHeight = this.containment?.clientHeight || 0;
      const offset = clientHeight * props.viewportOffset;
      this.offset = { bottom: -offset };
    }

    this.load = this.load.bind(this);
  }

  load(isVisible) {
    const { load } = this.props;
    if (isVisible) {
      const keepAlive = load();
      this.setState({ active: keepAlive });
    }
  }

  render() {
    const { active } = this.state;
    const { containment, offset } = this;

    return active ? (
      <VisibilitySensor onChange={this.load} partialVisibility delayedCall scrollCheck offset={offset} containment={containment} />
    ) : null;
  }
}

ScrollLazyLoad.propTypes = {
  load: PropTypes.func.isRequired,
  viewportOffset: PropTypes.number,
  container: PropTypes.string,
};
